export default __webpack_public_path__ + "static/media/D1.b4041f1a.png";